import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gkf_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("gkf_token");
      if (window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export const COMPANY = {
  name: "GK Fleet Private Limited",
  short: "GK Fleet",
  founder: "V. Karthik Neal",
  phone: "+91 80969 08008",
  phoneRaw: "+918096908008",
  email: "gkfleet25@gmail.com",
  hq: "Hyderabad, India",
  whatsapp: "https://wa.me/918096908008?text=Hi%20GK%20Fleet%2C%20I%27d%20like%20to%20learn%20more.",
  primary_message: "Empowering Drivers. Scaling Mobility.",
  secondary_message: "Building India's Most Driver-Focused Fleet Company.",
};

export const IMG = {
  hero: "https://static.prod-images.emergentagent.com/jobs/cf49702f-b3a2-4fff-b767-8c16071670ed/images/52d246b50a00aff3e793b9dd4ff7374218feafd059ef662ab2e7711901a3d3ff.png",
  driver: "https://static.prod-images.emergentagent.com/jobs/cf49702f-b3a2-4fff-b767-8c16071670ed/images/ce84a152fac115d8862f58151cee2522e16d2eb0bdbf9e0acaf15a3c500c1eb2.png",
  network: "https://static.prod-images.emergentagent.com/jobs/cf49702f-b3a2-4fff-b767-8c16071670ed/images/004db1b4391a42cd7907ae4c5edf4546b7cdce4e5b640109429556b3766a3495.png",
  hyderabad: "https://images.pexels.com/photos/13224856/pexels-photo-13224856.jpeg",
};
